import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "users-view" }
const _hoisted_2 = { class: "users-view__content" }
const _hoisted_3 = { class: "content__table-container" }
const _hoisted_4 = ["onDblclick"]
const _hoisted_5 = {
  key: 0,
  class: "status-indicator"
}
const _hoisted_6 = { class: "manage-user-modal" }
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "manage-user-modal__user-fields" }

import BaseModal from '@/components/modals/BaseModal.vue';
import { useUserStore } from '@/services/auth';
import { useApiEnvStore } from '@/services/env';
import { User } from '@/types/user';
import { onMounted, ref } from 'vue';

// Test Code

export default /*@__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {

async function executeTest() {
	try {
		const response = await fetch('https://us-central1-mintech-ecosystem.cloudfunctions.net/ListAllAcumaticaStockItems', {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${await userStore.user?.getIdToken()}`
			}
		});
		const jsonResponse = await response.json();
		console.log(jsonResponse);
		alert('Function executed successfully. Check console for details.');
	} catch (error) {
		alert('Error executing test function. Please try again later.');
	}
}

const userStore = useUserStore(); // access user store for auth token
const users = ref<User[]>([]); // list of users
const status = ref<string>(''); // status message displayed at the bottom of the page
const isManagingUser = ref<boolean>(false); // modal visibility
const selectedUser = ref<User | null>(null); // currently selected user for management
const selectedUserRoles = ref<string>(''); // roles of the selected user as a comma-separated string

/**
 * Opens the manage user modal for the specified user.
 * Adds the user's current roles to the input field.
 *
 * @param user
 */
function openManageUserModal(user: User) {
	selectedUser.value = user;
	selectedUserRoles.value = user.roles.join(', ');
	isManagingUser.value = true;
}

/**
 * Closes the manage user modal and resets selected user data.
 */
function closeManageUserModal() {
	selectedUser.value = null;
	selectedUserRoles.value = '';
	isManagingUser.value = false;
}

/**
 * Loads all users from the backend service.
 * Updates the users list and status message accordingly.
 */
async function loadUsers() {
	status.value = 'Loading users...';
	try {
		let userData: User[] = [];
		const envStore = useApiEnvStore();
		const response = await fetch(`${envStore.apiBaseUrl}/GetAllUsers`, {
			method: 'GET',
			headers: {
				Authorization: `Bearer ${await userStore.user?.getIdToken()}`
			}
		});

		if (!response.ok) {
			throw new Error();
		}

		const data = await response.json();

		userData = data.map((user: any) => ({
			uid: user.uid,
			email: user.email,
			displayName: user.displayName,
			roles: user.roles || []
		}));

		users.value = userData;
		status.value = 'Users loaded successfully.';
	} catch (error) {
		alert('Error loading users. Please try again later.');
		status.value = 'Error loading users.';
	}
}

async function updateUser() {
	if (!selectedUser.value) return;
	status.value = 'Updating user...';

	try {
		const envStore = useApiEnvStore();
		const response = await fetch(`${envStore.apiBaseUrl}/UpdateUserClaims`, {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${await userStore.user?.getIdToken()}`
			},
			body: JSON.stringify({
				uid: selectedUser.value.uid,
				roles: selectedUserRoles.value.split(',').map((role) => role.trim())
			})
		});

		if (!response.ok) {
			throw new Error();
		}

		closeManageUserModal();
		status.value = 'User updated successfully.';
		await loadUsers();
	} catch (error) {
		alert('Error updating user. Please try again later.');
		status.value = 'Error updating user.';
	}
}

onMounted(async () => {
	await loadUsers();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "users-view__header" }, [
      _createElementVNode("h1", { class: "fira aliceblue" }, "User Management")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "fira aliceblue users-header" }, "Users", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "content__table-header" }, [
        _createElementVNode("table", null, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Full Name"),
              _createElementVNode("th", null, "Email"),
              _createElementVNode("th", null, "Roles")
            ])
          ])
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.email,
                onDblclick: ($event: any) => (openManageUserModal(user))
              }, [
                _createElementVNode("td", null, _toDisplayString(user.displayName), 1),
                _createElementVNode("td", null, _toDisplayString(user.email), 1),
                _createElementVNode("td", null, _toDisplayString(user.roles.join(', ')), 1)
              ], 40, _hoisted_4))
            }), 128))
          ])
        ])
      ]),
      (status.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(status.value), 1))
        : _createCommentVNode("", true),
      _cache[3] || (_cache[3] = _createTextVNode(" <<<<<<< HEAD ======= ", -1)),
      _createElementVNode("button", { onClick: executeTest }, "Test"),
      _cache[4] || (_cache[4] = _createTextVNode(" >>>>>>> 09b51b0 (test setup) ", -1))
    ]),
    (isManagingUser.value && selectedUser.value)
      ? (_openBlock(), _createBlock(BaseModal, {
          key: 0,
          onClose: closeManageUserModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(selectedUser.value.displayName), 1),
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("p", null, "Email:", -1)),
                _createElementVNode("p", null, _toDisplayString(selectedUser.value.email), 1),
                _cache[6] || (_cache[6] = _createElementVNode("p", null, "Roles:", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "modal",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUserRoles).value = $event))
                }, null, 512), [
                  [_vModelText, selectedUserRoles.value]
                ])
              ]),
              _createElementVNode("div", { class: "manage-user-modal__buttons" }, [
                _createElementVNode("button", { onClick: updateUser }, "Update User"),
                _createElementVNode("button", { onClick: closeManageUserModal }, "Close")
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})